// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__6Tnmm","productName":"Table_productName__3d_qw"};